import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import md5 from 'md5'
import TextField from 'src/components/mui/TextField'
import Button from 'src/components/mui/MuiButton'
import { useAppDispatch, useAppSelector } from 'src/store/index'
import { handleSnackbarOpen } from 'src/store/slice/RootSnackbarSlice'
import { loginSuccess } from 'src/store/slice/LoginSlice'
import * as LoginService from 'src/services/LoginService'
import './login.css'

const Login = () => {
  const { logined } = useAppSelector(state => state.LoginSlice)
  const dispatch = useAppDispatch()

  const [formdata, setFormdata] = useState({ username: '', password: ''})
  const handleChang = (e, name) => {
    setFormdata({ ...formdata, [name]: e.target.value })
  }
  const submitLoginClick = () => {
    const { username, password } = formdata
    if (!username) {
      dispatch(handleSnackbarOpen({ message: '请输入账户', type: 'error' }))
      return
    }
    if (!password) {
      dispatch(handleSnackbarOpen({ message: '请输入密码', type: 'error' }))
      return
    }
    const param = { username: formdata.username, password: md5(formdata.password) }
    LoginService.login(param, (resp) => {
      if (resp.success) {
        const { userInfo } = resp
        dispatch(loginSuccess({ userInfo }))
      }
    })
  }
  const handleKeyup = (e) => { if (e.keyCode === 13) submitLoginClick() }
  if (logined) {
    return <Navigate to="/" />
  }
  return (
    <div className="LOGIN">
      <div className="login-container">
        <div className="form-container">
          <div className="title"><span>MANAGE.JOEDAR</span></div>
          <div className="form">
            <div className="item">
              <TextField type="text" placeholder="请输入账户" label="账户" variant="outlined" value={formdata.username} width="15em" onKeyUp={handleKeyup} onChange={(e) => handleChang(e, 'username')} />
            </div>
            <div className="item">
              <TextField type="password" placeholder="请输入密码" label="密码" variant="outlined" value={formdata.password} width="15em" onKeyUp={handleKeyup} onChange={(e) => handleChang(e, 'password')} />
            </div>
            <div className="item">
              <Button variant="contained" color="primary" children="登录" width="15em" onClick={submitLoginClick} />
            </div>
            <div className="item" style={{ display: 'none' }}>
              <Button
                variant="contained"
                color="primary"
                children="test"
                width="15em"
                onClick={() => {
                  LoginService.testGet((resp) => {
                    console.log('LoginService.testGet resp ', resp)
                  })
                }} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
